'use client'

import type { NewsletterSignupProps } from '@maestro/commerce-blocks/components/newsletter-signup/newsletter-signup.types'
import type { SettingsGlobal } from '@maestro/data-layer'

import { TrackingButton } from '@maestro/commerce-blocks/components/tracking-button'
import { Accordion, AccordionItem } from '@pearlconvert/ui/components/accordion'
import { useBreakpoint } from '@pearlconvert/ui/providers/breakpoint/breakpoint.context'

const NewsletterSignupContent = ({
  settings,
}: {
  settings: SettingsGlobal
}) => {
  return (
    <>
      <p>{settings.subscriptionDescription}</p>
      <TrackingButton
        location="footer"
        className="footer__button"
        url={settings.subscriptionUrl}
      >
        {settings.subscriptionButtonTitle}
      </TrackingButton>
    </>
  )
}

const NewsletterSignup = ({ isDesktop, settings }: NewsletterSignupProps) => {
  const { isMobileView } = useBreakpoint()

  if (!settings || !settings.subscriptionEnabled) {
    return null
  }

  const content = <NewsletterSignupContent settings={settings} />

  if (isDesktop) {
    return (
      <>
        <h3 className="footer__nav-title footer__nav-title--newsletter">
          {settings.subscriptionTitle}
        </h3>
        {content}
      </>
    )
  }

  return (
    <Accordion canOpenMultiple>
      <AccordionItem
        title={
          <h3 className="footer__nav-title footer__nav-title--newsletter">
            {settings.subscriptionTitle}
          </h3>
        }
        location="Footer"
      >
        {isMobileView() && content}
      </AccordionItem>
    </Accordion>
  )
}

export default NewsletterSignup
